import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: '/admin/steps',
  urlRoot: '/admin/steps',

  mutations: {
    updateComplete(state) {
      state.isUpdating = false
    }
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`/admin/steps/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    },

    sortList({ commit }, step_ids) {
      commit('updateStart')
      return http.put('/admin/steps/sort', { step_ids }).finally(() => {
        commit('updateComplete')
      })
    },

    sortFiles({ commit }, hashes) {
      commit('updateStart')
      return http.put('/admin/steps/files/sort', { hashes }).finally(() => {
        commit('updateComplete')
      })
    },

    removeFile({ commit }, hash) {
      commit('updateStart')
      return http.delete(`/admin/steps/files/${hash}`).finally(() => {
        commit('updateComplete')
      })
    }
  }
})
